export default {
  // Hero
  contactHeroTag: "Contactez-Nous",
  contactHeroTitle1: "Construisons Quelque Chose",
  contactHeroTitle2: "Ensemble en Afrique",
  contactHeroDesc: "Que vous cherchiez à enregistrer une entreprise, explorer des opportunités d'investissement, ou obtenir des conseils experts sur la conformité réglementaire en Afrique de l'Est — notre équipe est prête à vous aider.",

  // Form
  formTitle: "Envoyez-Nous un Message",
  formDesc: "Notre équipe répond généralement dans les 24 heures les jours ouvrables.",
  formSuccessTitle: "Message envoyé avec succès!",
  formSuccessBody: "Merci de nous avoir contactés. Nous vous répondrons sous peu.",
  formError: "Une erreur s'est produite. Veuillez réessayer ou nous envoyer un email directement.",
  formName: "Nom complet",
  formEmail: "Adresse email",
  formPhone: "Numéro de téléphone (avec indicatif pays)",
  formSubject: "Sujet",
  formCompany: "Entreprise / Organisation",
  formMessage: "Message",
  formMessagePlaceholder: "Dites-nous comment nous pouvons vous aider — plus de détails, mieux nous pourrons vous assister.",
  formSubmit: "Envoyer le Message",
  formSending: "Envoi en cours…",
  formSelectTopic: "Sélectionnez un sujet…",
  subjectCompanyReg: "Enregistrement d'Entreprise",
  subjectCompliance: "Conformité Réglementaire",
  subjectInvestment: "Facilitation de l'Investissement",
  subjectTender: "Support d'Appels d'Offres",
  subjectExpansion: "Expansion Commerciale",
  subjectGeneral: "Demande Générale",

  // Info
  infoOffice: "Notre Bureau",
  infoPhone: "Téléphone",
  infoEmail: "Email",
  infoHours: "Heures d'Ouverture",
  infoHoursWeekday: "Lundi – Vendredi: 8h00 – 18h00",
  infoHoursSaturday: "Samedi: 9h00 – 13h00",
  infoFollowUs: "Suivez-Nous",
  infoLine1: "KG 9 Ave, Kiyovu",
  infoLine2: "Kigali, Rwanda",
  infoEmail1: "info@africainvestmentportal.com",
  infoEmail2: "support@africainvestmentportal.com",
};